import { AxiosPromise } from "axios";
import { getDeviceId, getDeviceName } from "utils/device";
import { request } from "utils/request";

interface LoginParam {
  username: string;
  password: string;
}

export interface UpdateProfileParam {
  staff: {
    name: string;
    avatar?: string;
  };
}

export const authApi = {
  login: (data: LoginParam): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/login",
      method: "post",
      data,
      headers: {
        "device-id": getDeviceId(),
        "device-name": getDeviceName(),
      },
    }),

  profile: (): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/profile",
      method: "get",
    }),

  updateProfile: (data: UpdateProfileParam): AxiosPromise<any> =>
    request({
      url: "/v1/admin/auth/profile",
      method: "patch",
      data,
    }),
};
